/**
 * 本地会话未读统计（与消息列表逻辑一致）。
 * conversationId 形如 {bz|tgz}_{registrationId}_{userId}。
 */

import { isCurrentUserConversationKey } from '@/views/conversation/utils/tool';

export { isCurrentUserConversationKey };

export function isMessageUnread(v: { read?: unknown }): boolean {
  const r = v.read;
  if (r === true || r === 1) return false;
  if (r === false || r === 0) return true;
  if (typeof r === 'string') {
    const s = r.toLowerCase();
    if (s === 'true' || s === '1') return false;
    if (s === 'false' || s === '0') return true;
  }
  return true;
}

export function computeLocalSessionUnreadCount(
  chatHistory: Record<string, any[]>,
  userId: unknown,
  roleType?: unknown,
): number {
  if (userId == null || userId === '') return 0;
  const supportChatTypes = ['person-message', 'flow', 'groupNotify'];
  let total = 0;
  for (const conversationId of Object.keys(chatHistory)) {
    if (!isCurrentUserConversationKey(conversationId, userId, roleType)) {
      continue;
    }
    const conversationHistory = chatHistory[conversationId]
      .filter((message) =>
        supportChatTypes.includes(String(message.chatType)),
      )
      .filter((v) => v.senderId != userId);
    conversationHistory.sort(
      (a, b) => (a.receiveTime ?? 0) - (b.receiveTime ?? 0),
    );
    if (conversationHistory.length === 0) continue;
    total += conversationHistory.filter((v) => isMessageUnread(v)).length;
  }
  return total;
}
